// Autogenerated file
export const mobileAppTypesEnum = {
    Driver: "Driver",
    Logist: "Logist",
    Director: "Director",
};
export const mobileAppTypes = [
    { label: "МП Водители", value: "Driver" },
    { label: "МП Логисты", value: "Logist" },
    { label: "Директор ТК", value: "Director" },
];
